<template>
  <div>
    <div class="card card-custom">
      <div class="card-header">
        <h3 class="card-title" style="width: 100%">
          <button onclick="location.href='../UIC/BlockAccountsClient'" type="button" class="float-left btn btn-sm btn-outline-secondary btn-default">
            <i class="fa fa-plus"></i> Add New
          </button>
          <button type="button" class="float-right btn btn-sm btn-danger" :disabled="masterList.length === 0" @click="deleteAll">
            <i class="fa fa-trash"></i> Delete All
          </button>
        </h3>
      </div>

      <div class="card-body">
        <div class="row mb-3">
          <div class="form-group col-md-4">
            <label>Status</label>
            <select class="form-control" v-model="statusFilter">
              <option value="ALL">ALL</option>
              <option value="ProscribedPersons">Proscribed Persons</option>
              <option value="DeProscribedPersons">De-Proscribed Persons</option>
              <option value="Denotified">Denotified</option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label style="visibility:hidden">Load</label>
            <button type="button" class="btn btn-success d-block" @click="load()">Load</button>
          </div>
        </div>

        <!-- ── Status Summary Boxes ── -->
        <div class="row g-2 mb-4">
          <div class="col-md-4">
            <div class="border rounded p-3 text-center" style="background:#fff5f5;">
              <div style="font-size:2rem;font-weight:600;color:#c0392b;">{{ proscribedCount }}</div>
              <div class="small" style="color: #c0392b; font-weight: 700; font-size: 1rem;">Proscribed Persons</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="border rounded p-3 text-center" style="background:#f0fbf3;">
              <div style="font-size:2rem;font-weight:600;color:#1e8449;">{{ deProscribedCount }}</div>
              <div class="small" style="color: #1e8449; font-weight: 700; font-size: 1rem;">De-Proscribed Persons</div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="border rounded p-3 text-center" style="background:#fdf6ec;">
              <div style="font-size:2rem;font-weight:600;color:#d68910;">{{ denotifiedCount }}</div>
              <div class="small" style="color: #d68910; font-weight: 700; font-size: 1rem;">Denotified Persons</div>
            </div>
          </div>
        </div>
        <!-- ── End Status Summary Boxes ── -->



        <table class="table table-sm table-bordered" id="myTable">
          <thead class="bg-custom">
            <tr>
              <th width="4%">Sr. No</th>
              <th width="10%">Partner Type</th>
              <th width="10%">Client Name</th>
              <th width="10%">Father Name</th>
              <th width="8%">CNIC NO</th>
              <th width="8%">City</th>
              <th width="5%">SRO NO</th>
              <th width="8%">Date of SCR</th>
              <th width="12%">Black List By</th>
              <th width="8%">SECP Email Date</th>
              <th width="8%">Status</th>
              <th width="4%">Group</th>
              <th width="5%">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, ind) in list" :key="ind">
              <td>{{ ind + 1 }}</td>
              <td>{{ item.PTR_TYPE }}</td>
              <td>{{ item.CLIENT_NAME }}</td>
              <td>{{ item.FATHERNAME }}</td>
              <td>{{ item.CNIC_NO }}</td>
              <td>{{ item.City }}</td>
              <td>{{ item.SRO_NO }}</td>
              <td>{{ formatDate(item.DATE_OF_SCR) }}</td>
              <td>{{ item.BLACK_LIST_BY }}</td>
              <td>{{ formatDate(item.SECP_EMAIL_DATE) }}</td>
              <td>{{ item.STATUS }}</td>
              <td>{{ item.GROUP_ID || '—' }}</td>
              <td>
                <button class="btn btn-primary btn-sm" @click="editClient(item)"><i class="fas fa-pencil-alt" /></button>
                <button class="btn btn-danger btn-sm ml-1" @click="deleteClient(item, ind)"><i class="fa fa-trash"></i></button>
              </td>
            </tr>
          </tbody>
        </table>

      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    data() {
      return {
        list: [],
        masterList: [],
        statusFilter: 'ALL'
      };
    },

    computed: {
      proscribedCount() {
        return this.masterList.filter(i => i.STATUS === 'Proscribed Person').length;
      },

      deProscribedCount() {
        return this.masterList.filter(i => i.STATUS === 'De-Proscribed Person').length;
      },

      denotifiedCount() {
        return this.masterList.filter(i => i.STATUS === 'Denotified').length;
      }
    },

    updated() {
      if (window.$ && !$.fn.dataTable.isDataTable('#myTable')) {
        $('#myTable').DataTable();
      }
    },
    created() {
      this.pageload();
    },
    methods: {
      pageload() {
        startReq();
        axios.get('/api/UICApi/pageLoadBlockAccountsClientList')
          .then(res => {
            endReq();
            this.list = res.data.list || [];
            this.masterList = res.data.list || [];
          })
          .catch(err => {
            endReq();
            console.error(err);
          });
      },
      formatDate(date) {
        return date ? new Date(date).toISOString().split('T')[0] : '';
      },
      editClient(item) {
        const dest = item.GROUP_ID
          ? '../UIC/BlockAccountsClient?groupId=' + item.GROUP_ID
          : '../UIC/BlockAccountsClient?id=' + item.BAL_ID;
        window.location.href = dest;
      },
      load() {
        var vm = this;
        startReq();
        axios.get("/api/UICApi/LoadBlockAccountsClientList", {
          params: { status: vm.statusFilter }
        })
          .then(function (res) {
            endReq();
            if ($.fn.DataTable.isDataTable('#myTable')) {
              $('#myTable').DataTable().destroy();
            }
            vm.list = res.data.list || [];
          })
          .catch((error) => {
            endReq();
            console.log(error);
          });
      },
      deleteAll() {
        const vm = this;
        Swal.fire({
          title: 'Delete ALL records?',
          html: 'This will permanently remove <b>' + vm.masterList.length + '</b> records.<br/>Type <b>DELETE</b> to confirm.',
          icon: 'warning',
          input: 'text',
          inputPlaceholder: 'DELETE',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Yes, Delete All!',
          cancelButtonText: 'Cancel',
          inputValidator: value => (value !== 'DELETE' ? 'Type DELETE to confirm' : null)
        }).then(result => {
          if (!result.isConfirmed) return;

          startReq();
          axios.post('/api/UICApi/DeleteALLBlockAccountsClient')
            .then(res => {
              endReq();
              if (res.data.status) {
                if ($.fn.DataTable.isDataTable('#myTable')) {
                  $('#myTable').DataTable().destroy();
                }
                vm.list = [];
                vm.masterList = [];
                Swal.fire({
                  icon: 'success',
                  title: 'Deleted!',
                  text: res.data.msg,
                  timer: 2000,
                  showConfirmButton: false
                });
              } else {
                Swal.fire({ icon: 'error', title: 'Error', text: res.data.msg });
              }
            })
            .catch(err => {
              endReq();
              console.error(err);
              Swal.fire({ icon: 'error', title: 'Error', text: 'Error deleting records.' });
            });
        });
      },
      deleteClient(item, ind) {
        const vm = this;
        Swal.fire({
          title: 'Are you sure?',
          text: 'Delete entry for ' + item.CLIENT_NAME + '?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#6c757d',
          confirmButtonText: 'Yes, Delete!',
          cancelButtonText: 'Cancel'
        }).then((result) => {
          if (result.isConfirmed) {
            startReq();
            axios.post('/api/UICApi/DeleteBlockAccountsClient', {
              BalId: item.BAL_ID
            })
              .then(res => {
                endReq();
                if (res.data.status) {
                  vm.list.splice(ind, 1);
                  const masterIndex = vm.masterList.findIndex(
                    x => x.BAL_ID === item.BAL_ID
                  );
                  if (masterIndex !== -1) {
                    vm.masterList.splice(masterIndex, 1);
                  }
                  Swal.fire({
                    icon: 'success',
                    title: 'Deleted!',
                    text: 'Entry deleted successfully.',
                    timer: 1500,
                    showConfirmButton: false
                  });
                } else {
                  Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: res.data.msg
                  });
                }
              })
              .catch(() => {
                endReq();
                Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: 'Error deleting entry.'
                });
              });
          }
        });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/ims/BlockAccountsClientList.vue